import { useEffect, useState, useContext } from "react";
import axios from 'axios';

import { Folder, Download, Delete } from "../../files/icons/index.js";

import { AppContext } from '../../context.js';

import { DatetimeToDate, DateToFormat } from "../../utils/datetime.js";

function FilesPreview(props) {
  const { ids, allowDelete = false } = props;

  const context = useContext(AppContext);

  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!ids || ids.length === 0) {
      setLoading(false);
      return;
    }
    
    // if (userList) {
    //   setUsers(userList);
    //   setLoading(false);
    //   return;
    // }
    
    let u = context.addSpiner();
    axios.post('/api/admin/files', {
      filter: {
        id: ids,
        archived: false, // Only get non-archived files
      },
    }).then((response) => {
      //setFiles(response.data.filter(f => !f.archivedAt)); // Filter out archived files
      setFiles(response.data.files);
      setLoading(false);
    }).catch((e) => {
      context.addError(e);
      context.removeSpiner(u);
    }).finally(() => {
      context.removeSpiner(u);
    });
  }, [ids]);

  if (loading) {
    return <></>;
  }

  function handleDelete(file) {
    if (!allowDelete) {
      return null;
    }

    let u = context.addSpiner();
    axios.post('/api/admin/files/' + file.id + '/archive', {
      // id: ids
    }).then((response) => {
      setFiles(files.filter(f => f.id !== file.id));
    }).catch((e) => {
      context.addError(e);
      context.removeSpiner(u);
    }).finally(() => {
      context.removeSpiner(u);
    });
  }

  if (!files || files.length === 0) {
    return (
      <span className="typo-normal-150">No files</span>
    );
  }

  return (
    <>
      {/* <div className="d-flex justify-content-between align-items-center">
        <span className="typo-normal-125 ms-1">{files.length} files</span>
      </div> */}
      {files.sort((a, b) => b.createdAt - a.createdAt).map((file) => {
        return (
          <FilesPreviewRow file={file} allowDelete={allowDelete} handleDelete={handleDelete} />
        );
      })}
    </>
  );
}

function FilesPreviewRow(props) {
  const { file, allowDelete, handleDelete } = props;

  const context = useContext(AppContext);

  const downloadFile = (file) => {
    axios.get('/api/admin/files/' + file.id, { 
      responseType: 'blob' 
    }).then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', file.name + "." + file.extension);
      document.body.appendChild(link);
      link.click();
    }).catch(error => {
      //setImageSrc(Profile);
    });
  }

  return (
    <div className="d-flex justify-content-between align-items-center item">
      <div className="d-flex justify-content-center align-items-center" style={{height: '40px', width: '60px', border: "1px solid #ddd"}}>
        {isFileForPreview(file.extension) ? (
          <Preview file={file} />
        ) : (
          <Folder height={16} width={16} color={'grey'} />
        )}
      </div>
      <div className="w-100 ps-1">
        <div className="typo-strong-150">{file.name}.{file.extension}</div>
        <div className="typo-normal-125 text-muted">Added {DateToFormat(DatetimeToDate(file.createdAt), context.dateFormat)} {DateToFormat(DatetimeToDate(file.createdAt), context.timeFormat === "us" ? "AMPM" : "HH:mm")} by {file.createdByName}</div>
      </div>
      <div className="item" onClick={() => downloadFile(file)}>
        <Download height={16} width={16} color={'grey'} />
      </div>
      {(allowDelete && !file.archivedAt) && (
        <div className="item" onClick={() => handleDelete(file)}>
          <Delete height={16} width={16} color={'grey'} />
        </div>
      )}
    </div>
  );
}

function isFileForPreview(extension) {
  var extentionForPreview = ['jpg', 'jpeg', 'png', 'tiff'];
  if (extentionForPreview.includes(extension)) {
    return true;
  }
  return false;
}

function Preview(props) {
  const { file, id } = props;

  const [fileId, setFileId] = useState(id || file.id);
  const [imageSrc, setImageSrc] = useState(null);

  useEffect(() => {
    axios.get('/api/admin/files/' + fileId, { 
        responseType: 'blob' 
    }).then(response => {
        const imageUrl = URL.createObjectURL(response.data);
        setImageSrc(imageUrl);
    }).catch(error => {
        //setImageSrc(Profile);
    });
  }, [fileId]);

  return (
    <img src={imageSrc} style={{maxHeight: '40px', maxWidth: '100%'}} />
  );
}

function Image(props) {
  const { file, id, onClick, style, alt = "Image" } = props;
  const context = useContext(AppContext);

  const [fileId, setFileId] = useState(id || file?.id);
  const [imageSrc, setImageSrc] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    setFileId(id || file?.id);
    setError(false);
  }, [file, id]);

  useEffect(() => {
    if (!fileId) {
      setError(true);
      return;
    }

    // Add timestamp to bypass cache
    axios.get('/api/admin/files/' + fileId + '?token=' + context.token, { 
        responseType: 'blob' 
    }).then(response => {
        const imageUrl = URL.createObjectURL(response.data);
        setImageSrc(imageUrl);
        setError(false);
    }).catch(error => {
        setError(true);
    });
  }, [fileId]);

  // If no image or error, show a placeholder that's clickable
  if (error || !imageSrc) {
    return (
      <div 
        onClick={onClick}
        style={{
          minHeight: '50px',
          minWidth: '50px',
          height: style?.height || '50px',
          width: style?.width || '50px',
          border: '2px dashed #ddd',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: onClick ? 'pointer' : 'default',
          color: '#999',
          fontSize: '12px',
          ...style
        }}
      >
        {alt || 'No image'}
      </div>
    );
  }

  return (
    <img src={imageSrc} style={{...style, cursor: onClick ? 'pointer' : 'default'}} onClick={onClick} alt={alt} />
  );
}

export { FilesPreview, isFileForPreview, Image };